"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Controls(_ref) {
  var onReset = _ref.onReset;

  try {
    var handleSubmitForm = function handleSubmitForm() {
      dispatch((0, _reduxForm.submit)('operation-payout-from-file'));
    };

    var handleResetSubmit = function handleResetSubmit() {
      onReset();
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": 'payout.dialog.notification.controls'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      type: 'button',
      mode: 'success',
      className: _defaultModule["default"]['button'],
      "data-locator": 'payout.dialog.notification.controls.submit',
      onClick: handleSubmitForm
    }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E"), /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      type: 'button',
      mode: 'danger',
      className: _defaultModule["default"]['button'],
      "data-locator": 'payout.dialog.notification.controls.reset',
      onClick: handleResetSubmit
    }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0440\u0435\u0435\u0441\u0442\u0440")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Controls;
exports["default"] = _default;